
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menus/reviews",
      function () {
        return require("private-next-pages/menus/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menus/reviews"])
      });
    }
  